import { ExtensionMetaData } from 'src/_common/models/redux/store';

export enum NativePlatform {
  ANDROID = 'android',
}
export interface IPlatform {
  isMobile: boolean;
  isDesktop: boolean;
  isAndroid: boolean;
  isIos: boolean;
  isIPhone: boolean;
  isOperaMobile: boolean;
  isChrome: boolean;
  isEdge: boolean;
  isOpera: boolean;
  isFirefox: boolean;
  isSafari: boolean;
  isMac: boolean;
  isIE: boolean;
  isExtension?: boolean;
  native?: NativePlatform | null;
  extensionMetaData?: ExtensionMetaData;
  isChromeExtInstalled?: boolean;
  isTablet: boolean;
}

export interface GenericObject {
  // If the object type is unknown use this
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const extensionPlatformType = {
  'google-docs': 'google-docs',
  'ms-word': 'ms-word',
  chrome: 'chrome-sidebar',
};
